import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar'
import ScrollTextAnimation from '../../components/ScrollTextAnimation/ScrollTextAnimation';
import MarquSection from '../../components/MarquSection/MarquSection';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo-5.png'
import ProjectSection from '../../components/ProjectSection/ProjectSection';

const ProjectPage = () => {
    return (
        <Fragment>

            <Navbar
                hclass={'wpo-site-header wpo-header-style'}
                page={'project'}
                Logo={Logo}
                col1={'col-lg-3 col-md-3 col-3 d-lg-none dl-block'}
                col2={'col-lg-5 col-md-6 col-6'}
                col3={'col-lg-5 col-md-1 col-1'}
                col4={'col-lg-2 col-md-2 col-2'}
            />

            {/* ✅ Wrapper: top white space + no horizontal scroll */}
            <div
                style={{
                    paddingTop: "clamp(150px, 10vw, 120px)",
                    overflowX: "hidden",
                }}
            >
                <ScrollTextAnimation />

                <ProjectSection hclass={'wpo-project-section title section-padding pt-0'} />

                <MarquSection />
            </div>

            <Footer />
            <Scrollbar />

        </Fragment>
    )
};

export default ProjectPage;
